import { USER_LOGOUT } from "redux-store/auth/actions";
import { reduceById } from "redux-store/reducers";

const initialState = {
  statusCode: null,
};

const paginatedInitialState = {
  ...initialState,
  count: 0,
  data: [],
  next: null,
  page: 0,
  pages: 0,
  previous: null,
  total: 0,
};

function getApiReducer(
  successActionType,
  failureActionType,
  _initialState = initialState,
) {
  return getApiPaginationReducer(
    successActionType,
    failureActionType,
    _initialState,
  );
}

/*
 * Pagination reducer differs from apiReducer because we do not truncate
 * payload response to payload.data only. Pagination reducer returns
 * ALL properties from the payload. This supports pagination metadata.
 */
function getApiPaginationReducer(
  successActionType,
  failureActionType,
  _initialState = paginatedInitialState,
) {
  function genericApiPaginationReducer(state = _initialState, action) {
    const { payload = {}, type } = action;
    const { response = {} } = payload;
    const { status: statusCode } = response;

    switch (type) {
      case successActionType:
        return {
          ...state,
          ...response.data,
          byId: reduceById({}, response.data.data),
          statusCode,
        };
      case failureActionType:
        return {
          ...state,
          statusCode,
        };
      case USER_LOGOUT:
        return _initialState;
      default:
        return state;
    }
  }

  return genericApiPaginationReducer;
}

export {
  getApiPaginationReducer,
  getApiReducer,
  initialState,
  paginatedInitialState,
};
